"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { usePathname, useSearchParams } from "next/navigation";
import { getSignInHref, getSignUpHref } from "@/lib/auth-redirect";

export function NavAuthLinks() {
  const t = useTranslations("Nav");
  const pathname = usePathname();
  const searchParams = useSearchParams();

  let signInHref = getSignInHref();
  let signUpHref = getSignUpHref();

  if (pathname === "/join" || pathname.startsWith("/join/")) {
    const qs = searchParams.toString();
    const joinPath = qs ? `${pathname}?${qs}` : pathname;
    signInHref = getSignInHref(joinPath);
    signUpHref = getSignUpHref(joinPath);
  }

  return (
    <>
      <Link
        href={signInHref}
        className="cursor-pointer rounded-lg border border-(--mk-cream-border) px-3 py-2 text-xs leading-none font-medium whitespace-nowrap text-(--mk-cream-75) no-underline transition-all hover:border-(--mk-cream-border-hover) hover:bg-(--mk-cream-bg-hover) hover:text-(--mk-cream) md:px-4 md:text-sm lg:px-5"
      >
        {t("signIn")}
      </Link>
      <Link
        href={signUpHref}
        className="cursor-pointer rounded-lg bg-(--mk-gold) px-3.5 py-2 text-xs leading-none font-semibold whitespace-nowrap text-(--mk-ink) no-underline transition-all hover:bg-(--mk-gold-light) hover:-translate-y-px md:px-4 md:text-sm lg:px-5 lg:tracking-wide"
      >
        <span className="lg:hidden">{t("getStarted")}</span>
        <span className="hidden lg:inline">{t("getStartedFree")}</span>
      </Link>
    </>
  );
}
